import {gql, useQuery} from '@apollo/client';

import {ProfileQueryHeader, ProfileQueryHeaderVariables} from '#apollo/schema';
import {FileImageVariant} from '#apollo/schema';

const profileQueryHeader = gql`
  query profileQueryHeader($imageVariant: FileImageVariant!) {
    me {
      id
      avatar {
        id
        url(variant: $imageVariant, raw: false)
      }
      userProfile {
        id
        initials @client
        firstName
        lastName
        email
      }
      subscription {
        id
      }
      mostRecentLabSubmission {
        id
      }
    }
  }
`;

export const useProfileHeader = () =>
  useQuery<ProfileQueryHeader, ProfileQueryHeaderVariables>(profileQueryHeader, {
    variables: {imageVariant: FileImageVariant.Size_160x160},
  });
